import { UserRoles } from '../../../user/entities/user-roles';
import {
    IconAdapterComponent,
    IconAdapterElement,
} from '../../../table/components/table-adapter/icon-adapter.component';
import { DateFormat, ItemType, TableConfig, TableItem } from '../../../table/entities/table';
import { PaginatedResponse } from '../../../common/entities/paginated-response';
import { StringItemAdapterComponent } from '../../../table/components/table-adapter/string-item-adapter.component';
import { TaskPlanTableResource, TaskPlanTableRowResource } from './task-plan-table.resource';

export class TaskPlanTableRow {
    title: string;
    start: string;
    end: string;
    responsibleRole: UserRoles | string;
    icons: IconAdapterElement[];

    constructor(resource: TaskPlanTableRowResource) {
        this.title = resource.title;
        this.start = resource.start ?? '-';
        this.end = resource.end ?? '-';
        this.responsibleRole = resource.responsibleRole;
    }
}

export class TaskPlanTable {
    id: number;
    title = '';
    config: TableConfig<TaskPlanTableRow[]> = new TableConfig<TaskPlanTableRow[]>();

    constructor(resource: TaskPlanTableResource, emptyLabel?: string) {
        this.id = resource.id;
        this.title = resource.title;
        this.config.emptyListLabel = emptyLabel;
        this.config.itemSettings = [
            TableItem.create({
                id: 'start',
                prop: 'start',
                header: 'Start',
                type: ItemType.ADAPTER,
                adapter: StringItemAdapterComponent,
                width: '15%',
                format: DateFormat.DATE,
                columnPosition: 0,
            }),
            TableItem.create({
                id: 'end',
                prop: 'end',
                header: 'Ende',
                type: ItemType.ADAPTER,
                adapter: StringItemAdapterComponent,
                format: DateFormat.DATE,
                width: '15%',
                columnPosition: 1,
            }),
            TableItem.create({
                id: 'title',
                prop: 'title',
                header: 'Aufgabe',
                type: ItemType.ADAPTER,
                adapter: StringItemAdapterComponent,
                width: '42%',
                columnPosition: 1,
            }),
            TableItem.create({
                id: 'responsibleRole',
                prop: 'responsibleRole',
                header: 'Zuständig',
                type: ItemType.ADAPTER,
                adapter: StringItemAdapterComponent,
                width: '24%',
                columnPosition: 2,
            }),
            TableItem.create({
                id: 'icon',
                prop: 'icons',
                header: '',
                type: ItemType.ADAPTER,
                adapter: IconAdapterComponent,
                width: '4%',
                columnPosition: 3,
            }),
        ];
        this.config.list = PaginatedResponse.init(resource.rows.map((it) => new TaskPlanTableRow(it)));
    }
}
